import { render, staticRenderFns } from "./Branchs.vue?vue&type=template&id=d3d89eee&"
import script from "./Branchs.vue?vue&type=script&lang=ts&"
export * from "./Branchs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports